import { getRequest, putRequest } from "../system/server-calls";
import responseHandler from "../system/server-response-handler";

const addOrUpdateTermsAndConditions = (data) =>
  putRequest("TermsAndCondition", data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

  const getTermsAndConditions = () =>
  getRequest("TermsAndCondition").then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

export const termsAndConditionsService = {
  addOrUpdateTermsAndConditions,
  getTermsAndConditions,
};
